import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormLabel } from './styles';

const Checkbox = ({ 
    checked, 
    onChange, 
    text,
    ...rest 
}) => (
    <FormGroup>
        <FormLabel htmlFor="leadFormCheckbox" className='checkboxContainer'>
                {text}
                <input
                    name="checkbox"
                    type="checkbox"
                    value={checked}
                    id="leadFormCheckbox"
                    onChange={onChange}
                />
                <span className='checkbox'></span>
        </FormLabel>
    </FormGroup>
);

Checkbox.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired
};

export default Checkbox;


// WEBPACK FOOTER //
// ./src/components/Form/Checkbox.js